import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    publishedAt: z.string().nullable(),

    metadata: z.object({
      title: z.string().min(1),
      description: z.string().min(1),
      image: z.object({
        data: z.object({
          id: z.number(),
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),

    hero: z.object({
      title: z.string().min(1),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
      links: z
        .array(
          z.object({
            label: z.string().min(1),
            to: z.string().min(1),
          }),
        )
        .max(2),
    }),

    info_cards: z.object({
      title: z.string().min(1),
      cards: z
        .array(
          z.object({
            title: z.string().min(1),
            description: z.string().min(1),
            icon: z.string().min(1),
          }),
        )
        .min(3),
    }),

    steps: z.object({
      title: z.string().min(1),
      description: z.string().min(1),
      features: z
        .array(
          z.object({
            title: z.string().min(1),
            description: z.string().min(1),
            icon: z.string().min(1),
          }),
        )
        .max(5),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string().min(1),
          }),
        }),
      }),
    }),

    contact_form: z.object({
      title: z.string().min(1),
      description: z.string().min(1),
      button: z.string().min(1),
    }),

    faqs: z.object({
      title: z.string().min(1),
      questions: z
        .array(
          z.object({
            label: z.string().min(1),
            content: z.string().min(1),
          }),
        )
        .min(1),
    }),

    cta_banner: z.object({
      title: z.string().min(1),
      description: z.string().min(1),
      links: z
        .array(
          z.object({
            label: z.string().min(1),
            to: z.string().min(1),
          }),
        )
        .min(1)
        .max(2),
    }),

    alert: z
      .object({
        actions: z
          .array(
            z.object({
              label: z.string().min(1),
              to: z.string().min(1),
              size: z.enum(['sm', 'md', 'lg', 'xl']),
              variant: z.enum(['solid', 'soft']),
            }),
          )
          .min(1)
          .max(2),
      })
      .nullable(),
  }),
})

export type schemaType = z.infer<typeof schema>
